<template>
  <div id="sun" class="work-page" :class="{ 'slider-active' : isSliderActive, 'detail-loaded' : isDetailVisible, 'work-page-loaded': isPageLoaded, 'work-library-modal': showModal }" @click="closeWorkShare">
    <div class="work__bg-wrap">
      <div class="work__bg">
        <img src="/assets/img/layout/bg-overview.jpg" class="work__bg-img"  alt="work background image">
      </div>
    </div>
    <div class="detail__bg" style="background-image: url('/assets/img/halley-comet/bg-info.jpg')"></div>
    <div class="container">
      <div class="page__top">
        <h1 class="page-top__title">{{ $t('halley-comet.title') }}</h1>
        <p class="page-top__text">Astronomicum Caesareum <br />
          (Apian, 1540)</p>
      </div>
      <main class="main main--halley-comet">
        <div class="work-content work-intro-ani-in">
          <div class="work__scaleable " :style="'height:'+ slideHeightLive +'px; width:'+ slideWidthLive +'px; margin-top:'+ marginTop +'px;'">
            <div class="sun__slider-wrap scale-item">
              <transition tag="div" name="sun__slide-img" mode="out-in">
                <div class="sun__slider" :class="[activeSlide > 0 ? 'active' : '']" :style="'height:'+ slideWidthLive +'px; width:'+ slideWidthLive +'px'">
                  <template v-for="(slide, index) in thisSlides" >
                    <svg preserveAspectRatio="xMaxYMin meet" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 1820 1580" :key="'key'+index" v-if="index == activeSlide" class="sun__slide-img">
                      <defs>
                        <clipPath :id="'clip_'+index" v-html="slide.clipath" ></clipPath>
                      </defs>
                      <image :clip-path="'url(#clip_'+index+')'" xlink:href="/assets/img/halley-comet/apian_comet.png" width="1820" height="1580"/>
                    </svg>
                  </template>
                </div>
              </transition>
              <transition tag="div" name="sun__slide-img" mode="out-in">
                <div class="sun__slider sun__slider--blur" :class="[activeSlide > 0 ? 'active' : '']" :style="'height:'+ slideWidthLive +'px; width:'+ slideWidthLive +'px'">
                  <template v-for="(slide, index) in thisSlides" >
                    <svg preserveAspectRatio="xMaxYMin meet" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 1820 1580" :key="'key'+index" v-if="index == activeSlide" class="sun__slide-img">
                      <defs>
                        <clipPath :id="'clip_'+index" v-html="slide.clipath" ></clipPath>
                      </defs>
                      <image :clip-path="'url(#clip_'+index+')'" xlink:href="/assets/img/halley-comet/apian_comet.png" width="1820" height="1580"/>
                    </svg>
                  </template>
                </div>
              </transition>
              <div class="sun-slider-bg" :style="'height:'+ slideWidthLive +'px; width:'+ slideWidthLive +'px'">
                <svg preserveAspectRatio="xMaxYMin meet" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 1820 1580" class="sun-slider-bg__img">
                  <image xlink:href="/assets/img/halley-comet/apian_comet.png" width="1820" height="1580" />
                </svg>
                <svg preserveAspectRatio="xMaxYMin meet" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 1820 1580" class="sun-slider-bg__img img--blur">
                  <defs>
                    <clipPath id="clip_bg-blur">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1379 29c18.6-.1 38.4-.8 55 3 6.2 1.4 15-.1 20 1 15.6 3.6 32.3-3.1 46 0 18.5 4.2 41.7-3 59 1h22c12 .3 24 .7 36 1 10.6 0 24.1-1 33 1h40c5.6.2 9.7 3.3 16 2 6.1-1.3 18.3-4.1 27-2 17.6 4.2 33.7 12.5 43 25 20.6 27.7 11 62.5 11 104 0 63.4-6 115.6-6 181-.3 23.3-.7 46.7-1 70 5.1 23.2 4 53.2 4 80 0 11.2-1.2 25.5 1 35v42c1 4.3 3 10.4 4 14-.3 7.7-.7 15.3-1 23 4.5 20.5.8 48.3 3 73 2.4 26.7 2 58.6 1 87-.4 10.5-2.8 22.3-5 32 .3 15.7.7 31.3 1 47v31c6.6 29.8 7.2 72.5 7 107-.1 12.8-7.1 23.9-4 37 4 17.1 2 42.6 2 63v20c2.8 12.8 1 31.4 1 46 0 13.3 1.7 30.4-1 42v226c4.4 20.1 3.2 69.4-3 84-20.5 48.3-70.6 43-137 43h-611c-11.3-.3-22.7-.7-34-1-14.8 3.2-35-2.5-51 1-7.5 1.6-28.5 4.9-37 3-3.8-.8-12.6-2.2-18-1-13.1 2.9-34.9 1.8-47-1-17.4-4-41.2 3.1-55 0H685c-85.1 0-177.8.5-258 1-82.7.3-165.3.7-248 1-52.2 0-96.2 6.9-128-17-20.8-15.6-24.6-46.8-20-80 .4-3.2-2.2-12.5-3-16-1.6-7.1 1.7-18.3 3-24 .3-12 .7-24 1-36 1.2-5.4 3.6-14.5 2-22-.8-3.8-2.2-12.7-1-18 3.9-17 2.7-41.6 3-63 .1-11.2 1.5-24-1-35-2-9 2.4-17.7 4-24 2.7-10.6 1-24.9 1-37 0-45.3-4-84.1-4-131v-74c0-16.8-.4-36.6 3-49-.3-10.3-.7-20.7-1-31 6.8-30.8-3.1-60.9 0-93-.7-7.7-1.3-15.3-2-23 2.2-10.2-2-27.2 1-41 .6-2.6 1.9-8.9 1-13-1.2-5.5-3.2-26.5-2-32 4.1-18.6 5-41.6 5-65-.3-10.7-.7-21.3-1-32 3.4-15.3 4.7-42 1-58-1.7-7.4 1.3-14.2 0-20-1.3-5.8 1-12.8 2-17 2.1-8.9 3-36.2 1-45-7.1-32-7-70-7-110 0-19.1-1.7-40.8 2-57v-59c5.4-24.3-.5-54.9 5-79 2.1-8.9-1.6-17.9 0-25 3-13.2-2.7-23.9 1-36 4.9-16.1 17.8-34.2 30-43 6.7-4.8 32.2-10.1 43-10 3.6 0 8.9 3.3 15 2 19.9-4.3 42.8-3.7 61-8h17c21.1 0 40.3 4 60 1 18.1-2.8 31 8 49 4 6.3-1.4 25.4-5.5 32-4 5.6 1.3 17.5 3.9 26 2 9-2 19.5-1 30-1h111c14.3-3.1 38.4 0 56 0 26.3-.3 52.7-.7 79-1 7.1 1.1 21.4 4.8 30 3 11-2.3 26-2 37-1 10.8 1 23.8-1.1 33 1h37c14 .3 28 .7 42 1 5-.3 10-.7 15-1 5.9 1.2 11.5 3.7 17 5 18.6 4.6 28.2-10.8 46-7 23.7 5 48.7 5 77 5 10.3 0 23.4 1 32-1 9.3-2.1 19.2-.2 27-2 3.1-.7 7.4.6 9 1h20c7.1.2 16.4 1.5 23 3 14.3 3.3 28.9-2.4 41-4 3.1-.4 10.3 1 15 1 18.6 0 37.5-1.6 54 2 6.6 1.4 20.6 3.8 28 2 19.6-4.6 36.9-9 61-9h58c6.4 0 18.6 1.7 23-1z"/>>
                    </clipPath>
                  </defs>
                  <image clip-path="url(#clip_bg-blur)" xlink:href="/assets/img/halley-comet/apian_comet.png" width="1820" height="1580" />
                </svg>
                <svg preserveAspectRatio="xMaxYMin meet" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 1820 1580" class="sun-slider-bg__img sun-mask-bg" :class="[activeSlide > 0 ? 'active' : '']">
                  <path fill="rgba(0,0,0,0.35)" fill-rule="evenodd" clip-rule="evenodd" d="M1379 29c18.6-.1 38.4-.8 55 3 6.2 1.4 15-.1 20 1 15.6 3.6 32.3-3.1 46 0 18.5 4.2 41.7-3 59 1h22c12 .3 24 .7 36 1 10.6 0 24.1-1 33 1h40c5.6.2 9.7 3.3 16 2 6.1-1.3 18.3-4.1 27-2 17.6 4.2 33.7 12.5 43 25 20.6 27.7 11 62.5 11 104 0 63.4-6 115.6-6 181-.3 23.3-.7 46.7-1 70 5.1 23.2 4 53.2 4 80 0 11.2-1.2 25.5 1 35v42c1 4.3 3 10.4 4 14-.3 7.7-.7 15.3-1 23 4.5 20.5.8 48.3 3 73 2.4 26.7 2 58.6 1 87-.4 10.5-2.8 22.3-5 32 .3 15.7.7 31.3 1 47v31c6.6 29.8 7.2 72.5 7 107-.1 12.8-7.1 23.9-4 37 4 17.1 2 42.6 2 63v20c2.8 12.8 1 31.4 1 46 0 13.3 1.7 30.4-1 42v226c4.4 20.1 3.2 69.4-3 84-20.5 48.3-70.6 43-137 43h-611c-11.3-.3-22.7-.7-34-1-14.8 3.2-35-2.5-51 1-7.5 1.6-28.5 4.9-37 3-3.8-.8-12.6-2.2-18-1-13.1 2.9-34.9 1.8-47-1-17.4-4-41.2 3.1-55 0H685c-85.1 0-177.8.5-258 1-82.7.3-165.3.7-248 1-52.2 0-96.2 6.9-128-17-20.8-15.6-24.6-46.8-20-80 .4-3.2-2.2-12.5-3-16-1.6-7.1 1.7-18.3 3-24 .3-12 .7-24 1-36 1.2-5.4 3.6-14.5 2-22-.8-3.8-2.2-12.7-1-18 3.9-17 2.7-41.6 3-63 .1-11.2 1.5-24-1-35-2-9 2.4-17.7 4-24 2.7-10.6 1-24.9 1-37 0-45.3-4-84.1-4-131v-74c0-16.8-.4-36.6 3-49-.3-10.3-.7-20.7-1-31 6.8-30.8-3.1-60.9 0-93-.7-7.7-1.3-15.3-2-23 2.2-10.2-2-27.2 1-41 .6-2.6 1.9-8.9 1-13-1.2-5.5-3.2-26.5-2-32 4.1-18.6 5-41.6 5-65-.3-10.7-.7-21.3-1-32 3.4-15.3 4.7-42 1-58-1.7-7.4 1.3-14.2 0-20-1.3-5.8 1-12.8 2-17 2.1-8.9 3-36.2 1-45-7.1-32-7-70-7-110 0-19.1-1.7-40.8 2-57v-59c5.4-24.3-.5-54.9 5-79 2.1-8.9-1.6-17.9 0-25 3-13.2-2.7-23.9 1-36 4.9-16.1 17.8-34.2 30-43 6.7-4.8 32.2-10.1 43-10 3.6 0 8.9 3.3 15 2 19.9-4.3 42.8-3.7 61-8h17c21.1 0 40.3 4 60 1 18.1-2.8 31 8 49 4 6.3-1.4 25.4-5.5 32-4 5.6 1.3 17.5 3.9 26 2 9-2 19.5-1 30-1h111c14.3-3.1 38.4 0 56 0 26.3-.3 52.7-.7 79-1 7.1 1.1 21.4 4.8 30 3 11-2.3 26-2 37-1 10.8 1 23.8-1.1 33 1h37c14 .3 28 .7 42 1 5-.3 10-.7 15-1 5.9 1.2 11.5 3.7 17 5 18.6 4.6 28.2-10.8 46-7 23.7 5 48.7 5 77 5 10.3 0 23.4 1 32-1 9.3-2.1 19.2-.2 27-2 3.1-.7 7.4.6 9 1h20c7.1.2 16.4 1.5 23 3 14.3 3.3 28.9-2.4 41-4 3.1-.4 10.3 1 15 1 18.6 0 37.5-1.6 54 2 6.6 1.4 20.6 3.8 28 2 19.6-4.6 36.9-9 61-9h58c6.4 0 18.6 1.7 23-1z"/>>
                </svg>
              </div>
            </div>
          </div>
          <div class="range-slider range-slider--horizontal scale-item" :style="'width:'+ rangeWidthLive +'px'">
            <div class="range-slider__handle-track--horizontal" :style="'transform: translateX(' + currentHandleLeft + 'px)'" ref="handle-track">
              <div class="range-slider__handle--horizontal">
                <span class="sicon sicon__slide-handle" aria-hidden="true"></span>
                <span class="visuallyhidden">Slide Handle</span>
              </div>
            </div>
            <div class="range-slider__track--horizontal">
              <div class="range-slider__track-line"></div>
            </div>
            <div id="range-interact"></div>
          </div>
          <div class="work__legend" :style="'bottom:' + legendBottom + 'px'" :class="[activeSlide > 0 ? 'active' : '']">
            <span v-for="(slide, index) in thisSlides" :key="'halley-comet__'+index" v-if="index == activeSlide" class="sun__legend-span" :style="'bottom:'+ legendBottom +'px'">{{ slide.legend }}</span>
          </div>
        </div>
        <detail v-on:show-modal="showModalMsg"></detail>
      </main>
    </div>
    <menuprimary current-nav="halley-comet" :needNavprojects=true  v-on:toggle-detail="toggleDetail"></menuprimary>
    <div class="top-tool-nav-wrap">
      <div @click="toggleDetail" v-if="isDetailVisible" class="btn-close-circle" aria-hidden="true">
        <span class="visuallyhidden">close detail content</span>
      </div>
      <share-section v-if="isDetailVisible"></share-section>
      <router-link to="overview" class="btn-close-circle" aria-hidden="true" v-else>
        <span class="visuallyhidden">go to overview page</span>
      </router-link>
      <router-link :to="'zoom-halley-comet/'+this.activeSlide" class="zoom-btn">
        <span class="sicon sicon__zoom-more" aria-hidden="true"></span>
        <span class="visuallyhidden">Link zu zoomed img</span>
      </router-link>
    </div>
    <modal v-if="showModal" url="https://www.e-rara.ch/zut/content/pageview/2435010" @close="showModal=false"></modal>
  </div>
</template>

<script>
  import halley from '../../data/halley-comet';
  import iHalleyComet from '../info/i-halley-comet';
  import Modal from '../../components/modal';
  import MenuPrimary from '../../components/menu-primary';
  import Slides from '../../data/planet-slides';
  import ShareSection from '../../components/share';

  import anime from 'animejs';
  import Hammer from '../../assets/js/hammer.min';

  export default {
    name: 'halleyCometComponent',
    components: {
      'detail': iHalleyComet,
      'modal': Modal,
      'menuprimary': MenuPrimary,
      'share-section': ShareSection
    },
    data() {
      return {
        activeSlide: 0,
        printIndex:1,
        bg: false,
        isSliderActive: false,
        thisSlides:halley.data()['slides'],
        currentHandleLeft : 0,
        showModal: false,
        isDetailVisible: false,
        windowWidth: 0,
        marginTop: 0,
        rangeWidthLive: 0,
        slideWidthLive: 0,
        slideHeightLive: 0,
        slides: Slides.data()['Slides'],
        legendBottom:'',
        workPosLive:'',
        zoomEl:'',
        mc:'',
        pinchTimmer:0,
        isPageLoaded: false,
        instAniInterval: null,
        instAniLoadTimer: null,
        pageLoadTimer: null,
      }
    },
    created() {
      this.currentHandleLeft = 0;
      this.isMobile = this.mobileAndTabletcheck()
    },
    methods: {
      instractionAni: function () {
        var step = 0;
        var _this = this;
        this.instAniInterval = setInterval(frame, 150);

        function frame() {
          if (step == 6 || _this.isDetailVisible) {
            _this.clearIntervalInstAni()

            if( _this.isDetailVisible){
              _this.isSliderActive = false;
            }
          } else {
            if((step >= 3 && step < 6)) {
              //3,4,5
              _this.stepDown()
            } else {
              //0,1,2,
              _this.stepUp()
            }
          }
          step++;
        }
      },
      clearIntervalInstAni : function() {
        if(this.instAniInterval) {
          clearInterval(this.instAniInterval);
        }
        if(this.instAniLoadTimer) {
          clearTimeout(this.instAniLoadTimer);
        }
      },
      stepUp: function () {
        this.activeSlide++
        if(this.activeSlide > this.thisSlides.length -1) {
          this.activeSlide = this.thisSlides.length -1
        }
        this.getHandlePos()
      },
      stepDown: function () {
        this.activeSlide--
        if(this.activeSlide < 0) {
          this.activeSlide = 0
        }
        this.getHandlePos()
      },
      getHandlePos: function () {
        var thisSlidesLength = this.thisSlides.length -1;
        var rangeHandle = this.$el.querySelector('.range-slider__handle--horizontal');
        var totalSlideWidth = this.$el.querySelector('.range-slider__track-line').clientWidth - rangeHandle.clientWidth;
        var stepPos = totalSlideWidth / thisSlidesLength;
        this.currentHandleLeft = this.activeSlide * stepPos
        this.isSliderActive = true
      },
      rangeHandleOnPan: function (e) {
        if(!this.isSliderActive ) {
          this.isSliderActive = true
        }

        // eslint-disable-next-line no-undef
        gtag('event', 'rangeSlider', {
          'event_category' : 'halley-comet',
          'event_label' : 'halley-comet',
        });

        var rangeHandle = this.$el.querySelector('.range-slider__handle--horizontal');
        var slidesLength = this.thisSlides.length - 1;
        var totalSlideWidth = this.$el.querySelector('.range-slider__track-line').clientWidth - rangeHandle.clientWidth;
        var stepPos = totalSlideWidth / slidesLength;
        var rangeInteract = this.$el.querySelector('#range-interact').getBoundingClientRect();
        var posOnPan = e.center.x + (rangeInteract.left * -1)- rangeHandle.clientWidth / 2;

        if(posOnPan >= totalSlideWidth){
          posOnPan = totalSlideWidth;
        }

        if(posOnPan <= 0){
          posOnPan = 0;
        }

        this.currentHandleLeft = posOnPan;

        var _curSlideIndex = Math.round(posOnPan  / stepPos);

        if(this.activeSlide != _curSlideIndex) {
          this.activeSlide = _curSlideIndex
        } else {
          return false
        }
      },
      showModalMsg : function() {
        this.showModal = true
      },
      toggleDetail:function () {
        if(!this.isDetailVisible) {
          // eslint-disable-next-line no-undef
          gtag('config', this.uaId, {'page_path': this.$route.path + '-i-detail'});
        } else {
          // eslint-disable-next-line no-undef
          gtag('config', this.uaId, {'page_path': this.$route.path });

          var audio = this.$el.querySelectorAll('audio')[0];
          if(!audio.paused){
            audio.pause();
          }
        }

        var _this = this;
        this.isDetailVisible =  !this.isDetailVisible
        var _scale = 1;
        var workHTo =  window.innerHeight - this.$el.querySelector('.nav-bottom').clientHeight;
        var translateScaledWork = 0;
        if(this.isDetailVisible) {
          document.body.classList.add('detail-opened');
          _scale = 0.7;
          this.resetWorkZoom();
          workHTo = this.rangeWidthLive;
          translateScaledWork = 140;

          if(window.innerWidth < 1025){
            translateScaledWork = 180;
          }
        } else {
          document.body.classList.remove('detail-opened');
        }

        anime({
          targets: [this.$el.querySelectorAll('.scale-item')],
          scale: _scale,
          translateY: translateScaledWork,
          duration: 500,
          easing:'easeOutQuart',
          complete: function() {
            _this.getRangeWidth();
          }
        });
        anime({
          targets: [this.$el.querySelector('.work-content')],
          height: workHTo,
          duration: 500,
          easing:'easeOutQuart',
        });
      },
      resizeWorkDetail: function() {
        var work = this.$el.querySelector(".work-content");
        if(this.isDetailVisible) {
          work.style.height =  this.rangeWidthLive * 0.7 + 'px';
        }
      },
      getRangeWidth: function() {
        const legend = this.$el.querySelector(".sun__legend-span");
        const range = this.$el.querySelector(".range-slider--horizontal");
        let legendH = legend.clientHeight;
        var pageTopPaddingTop = parseInt(getComputedStyle(this.$el.querySelector(".page__top")).paddingTop);
        var winW = window.innerWidth;
        var winH = window.innerHeight;
        var workH = winH - this.$el.querySelector(".nav-bottom").clientHeight;
        var imageRatio = 1820/1580;

        var availH = workH - this.$el.querySelector(".page__top").clientHeight - legendH - 60;

        if(winW > 1200 & winH < 750){
          availH = workH - this.$el.querySelector(".page-top__title").clientHeight - pageTopPaddingTop * 2 - legendH - winH * 0.045 - 20;
        }

        var _bottomNav = parseInt(window.getComputedStyle(this.$el.querySelector(".nav-bottom")).getPropertyValue("bottom"))
        if(_bottomNav  > 0) {
          availH = availH - _bottomNav
        }
        if(availH < 200) {
          availH = 200
        }

        var maxAailH = Math.min(winW, availH)
        this.slideHeightLive = maxAailH;
        this.slideWidthLive = this.slideHeightLive * imageRatio;

        if(winH > 1150){
          this.slideWidthLive = maxAailH;
          this.slideHeightLive = this.slideWidthLive / imageRatio;
        }


        if(winW < 900 || this.slideWidthLive > this.$el.querySelector('.work-content').clientWidth){
          var maxAailW = Math.min((winW - 40), availH - 12)

          this.slideWidthLive = maxAailW;
          this.slideHeightLive = this.slideWidthLive / imageRatio;
        }

        if(winW > winH && winW <= 926 && this.isMobile){
          this.slideWidthLive = this.slideWidthLive * 0.9;
        }

        this.rangeWidthLive = this.slideWidthLive * 0.8256;

        if(winW < 768){
          this.rangeWidthLive = this.slideWidthLive * 0.96538461538461538;
        }

        this.legendBottom = this.slideWidthLive * 0.02;

        if(!this.isDetailVisible) {
          this.$el.querySelector('.work-content').style.height = workH + 'px';
        }

        if(winW > 1200 && winH < 750){
          range.style.bottom = this.legendBottom + legendH + 16 + "px";
        } else {
          range.style.bottom = this.legendBottom + legendH + range.clientHeight - 12 + "px";
        }

        if(winW < 1025){
          this.legendBottom = this.slideWidthLive * 0.012;
          //this.marginTop = parseInt(getComputedStyle(this.$el.querySelector(".page-top__text")).marginBottom);
          range.style.bottom = parseInt(getComputedStyle(range).bottom) + "px";

          if(winW < 900){
            this.marginTop = parseInt(getComputedStyle(this.$el.querySelector(".page-top__text")).marginBottom);
          }

          if(winW < 768){
            this.marginTop = parseInt(getComputedStyle(this.$el.querySelector(".page-top__text")).marginBottom) + 10;
            this.legendBottom = this.slideWidthLive * 0.044;
            range.style.bottom = this.legendBottom + legendH + range.clientHeight -2 + "px"
          }

          if(winW > winH && winW <= 926 && this.isMobile){
            this.marginTop = 0;
            range.style.bottom = this.legendBottom + range.clientHeight - 6 +  "px"
            this.legendBottom = this.slideWidthLive * 0.03;
          }
        } else {
          this.marginTop = 0;
        }

      },
      resetWorkZoom : function() {
        var transform = "";
        this.zoomEl.style.transform = transform;
        this.zoomEl.style.webkitTransform = transform;
      },
      pageLoad : function() {
        this.isPageLoaded = true
        var _this = this
        this.pageLoadTimer = setTimeout(function () {
          _this.$el.querySelector(".work-intro-ani-in").classList.remove("work-intro-ani-in")
        }, 1600)
      },
    },
    beforeRouteLeave (to, from, next) {
      this.clearIntervalInstAni()
      if(this.pageLoadTimer) {
        clearTimeout(this.pageLoadTimer);
      }
      document.body.classList.remove('detail-opened');
      localStorage.setItem('halleyIndex', '')
      this.aniMenuPageLeave(next());
    },
    mounted() {
      this.saveCurrentPlanetToLocalStorage();
      this.zoomEl = this.$el.querySelector(".work__scaleable");
      const rangeInteract = this.$el.querySelector("#range-interact");
      const mc = new Hammer.Manager(rangeInteract);
      this.windowWidth = window.innerWidth

      mc.domEvents = true
      mc.add( new Hammer.Pan({ direction: Hammer.DIRECTION_ALL, threshold:0}) );
      mc.add( new Hammer.Tap() );
      mc.on('panmove', (e) => {
        var old = this.pinchTimmer
        var now = new Date().getTime(),
          delta = now - old;

        this.clearIntervalInstAni()

        //avoid pinch end -> pan
        if(delta > 100) {
          this.pinchTimmer = 0
          this.rangeHandleOnPan(e)
        }
      });

      var lastX = 0;
      mc.on('tap', (e) => {
        this.clearIntervalInstAni()
        var posX = e.srcEvent.layerX

        if(posX > lastX){
          this.stepUp()
          lastX = posX - 1;
        } else {
          this.stepDown()
          lastX = posX + 1;
        }
      });

      this.mc = mc;
      this.getRangeWidth();
      this.pageLoad();
      this.setWorkBgPos();

      if(localStorage.getItem('halleyIndex')) {
        var _this = this;
        _this.activeSlide = localStorage.getItem('halleyIndex');
        setTimeout(function (){
          _this.getHandlePos();
        },10);
      } else {
        this.instAniLoadTimer = setTimeout(this.instractionAni,2000)
      }

      window.onresize = () => {
        if(this.isMobile && this.windowWidth == window.innerWidth) {
          return false
        }
        this.getRangeWidth();
        this.getHandlePos();
        this.resizeWorkDetail();
        this.windowWidth = window.innerWidth
      }


      window.onorientationchange = () => {
        this.getRangeWidth();
        this.getHandlePos();
      }
    }
  }
</script>
